import cl from 'classnames';
import React from 'react';

import DetailListItem, { DetailListItemProps } from './detail-list-item/DetailListItem';

import './DetailList.scss';

interface DetailListProps extends React.HTMLAttributes<HTMLDivElement> {
    /** Optional header above the rows */
    header?: string;
    /** Optional additional class names */
    className?: string;
    /** Pass \<DetailList.Item /> as children. */
    children?: React.ReactNode;
}

interface DetailListComponent {
    Item: React.FC<DetailListItemProps>;
}

interface HeaderProps {
    header?: string;
}

interface ContentProps {
    children?: React.ReactNode;
}

const Header = ({ header }: HeaderProps) => {
    if (!header) {
        return null;
    }

    return (
        <header>
            <h3 className="typography-h3">{header}</h3>
        </header>
    );
};

const Content = ({ children }: ContentProps) => {
    if (!children) {
        return null;
    }

    return <dl className="kortbetjening-detail-list">{children}</dl>;
};

const DetailList: React.FC<DetailListProps> & DetailListComponent = ({
    header,
    className,
    children,
    ...rest
}): React.JSX.Element => (
    <div {...rest} className={cl('kortbetjening-detail-list-wrapper', className)}>
        <Header header={header} />
        <Content>{children}</Content>
    </div>
);

DetailList.Item = DetailListItem;

export default DetailList;
